import React, { useEffect } from "react";
import Constitution from "../components/Constituion/constitution";
import Footer from "../components/Footer/footer";
import Navbar from "../components/Navbar/navbar";

const Constitutionpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Navbar />
      <Constitution />
      <Footer />
    </div>
  );
};

export default Constitutionpage;
